import {
    ConfigQuery as SourceConfigQuery
} from 'SourceQuery/Config.query';
import { Field } from 'Util/Query';

/** @namespace Elganso/Query/Config/Query */
export class ConfigQuery extends SourceConfigQuery {
    _getStoreConfigFields() {
        return [
            'id',
            'code',
            'is_active',
            'cms_home_page',
            'cms_no_route',
            'copyright',
            'timezone',
            'header_logo_src',
            'timezone',
            'title_prefix',
            'title_suffix',
            'default_display_currency_code',
            'default_keywords',
            'default_title',
            'default_description',
            'default_country',
            'downloadable_links_target_new_window',
            'secure_base_media_url',
            'logo_alt',
            'logo_height',
            'logo_width',
            'cookie_text',
            'cookie_link',
            'terms_are_enabled',
            'address_lines_quantity',
            'base_url',
            'pagination_frame',
            'pagination_frame_skip',
            'anchor_text_for_previous',
            'anchor_text_for_next',
            'reviews_are_enabled',
            'reviews_allow_guest',
            'wishlist_general_active',
            'demo_notice',
            'guest_checkout',
            'is_email_confirmation_required',
            'display_product_stock_status',
            'base_link_url',
            'show_vat_number_on_storefront',
            'show_tax_vat_number',
            'product_use_categories',
            'category_url_suffix',
            'cookie_lifetime',
            'plp_list_mode',
            'layered_navigation_product_count_enabled',
            'region_display_all',
            'redirect_dashboard',
            'product_alert_allow_price',
            'product_alert_allow_stock',
            'newsletter_general_active',
            'newsletter_subscription_allow_guest_subscribe',
            'newsletter_subscription_confirm',
            'delivery_instore_active',
            'access_token_lifetime',
            'is_allowed_reorder',
            'rss_order_subscribe_allow',
            'downloadable_disable_guest_checkout',
            'minimun_password_length',
            'required_character_classes_number',
            'threshold_qty',
            'useCustomLoginPage',
            'enableAccesibilidad',
            'redondeoRebajas',
            'recomendadorTallasActivo',
            'gruposRemarketing',
            'show_gender',
            ...this._getTimeDateFormatFields(),
            this.getPriceDisplayTypeField(),
            this.getTableCookieData(),
            this.getCarritoPromocionesConfig(),
            this.getDonacionesConfig(),
            this.getInvitaGanaConfig(),
            this.getChatbotConfig(),
            this.getTarjetasMonederoConfig(),
            this.getEncuestasConfig(),
            this.getSocialLoginConfig(),
            this.getSocialConfig(),
            this.getCheckoutAddressConfig(),
            this.getFraseHeadConfig()
        ];
    }

    getFraseHeadConfig() {
        return new Field('fraseHeadConfig')
            .addFieldList([
                'enabled',
                'texto_1',
                'link_1',
                'texto_2',
                'link_2',
                'texto_3',
                'link_3',
                'texto_mobile_1',
                'link_mobile_1',
                'texto_mobile_2',
                'link_mobile_2',
                'texto_mobile_3',
                'link_mobile_3',
                'segundos_slider',
                'abrirennuevapest',
                'mostrarsoloenhome',
                'backgoundfondo',
                'backgoundfondo_movil',
                'colortexto',
                'colortexto_movil',
                'fuente',
                'estiloadicionalbloque',
                'estiloadicionalenlace'
            ]);
    }

    getCheckoutAddressConfig() {
        return new Field('checkoutAddressConfig')
            .addFieldList([
                'enabled',
                'api_key_autocompletar',
                'configure_options'
            ]);
    }

    getSocialConfig() {
        return new Field('socialMediaConfig')
            .addFieldList([
                'linkedin',
                'facebook',
                'instagram',
                'twitter',
                'pinterest',
                'youtube'
            ]);
    }

    getSocialLoginConfig() {
        return new Field('socialLoginConfig')
            .addFieldList([
                'configuracion'
            ]);
    }

    getEncuestasConfig() {
        return new Field('encuestasConfig')
            .addFieldList([
                'enabled',
                'form_id'
            ]);
    }

    getTarjetasMonederoConfig() {
        return new Field('tarjetasMonederoConfig')
            .addFieldList([
                'disabled',
                'texto_tarjetas_monedero'
            ]);
    }

    getChatbotConfig() {
        return new Field('chatbot')
            .addFieldList([
                'activo'
            ]);
    }

    getInvitaGanaConfig() {
        return new Field('invitaGanaConfig')
            .addFieldList([
                'enabled_invita',
                'tipo_invita',
                'frase_invita_puntos',
                'frase_invita_bonos',
                'descripcion_invita_puntos',
                'descripcion_invita_bonos',
                'puntos_ganados_invita',
                'invitar_por_email',
                'invitar_por_link',
                'ratio_points'
            ]);
    }

    getTableCookieData() {
        return new Field('tableCookieData')
            .addFieldList([
                'necessary_cookie',
                'preference_cookie',
                'statistic_cookie',
                'marketing_cookie'
            ]);
    }

    getCarritoPromocionesConfig() {
        return new Field('carritoPromocionesData')
            .addFieldList([
                'enabled',
                'texto_abrir',
                'texto_cerrar',
                'texto_promo_item',
                'date_format',
                'promo_registrados'
            ]);
    }

    getDonacionesConfig() {
        return new Field('donacionesData')
            .addFieldList([
                'enabledDonaciones',
                'empleadoDonaciones',
                'tituloDonaciones',
                'descripcionDonaciones',
                'actionDonaciones',
                'enabledAsociaciones',
                'tituloAsociaciones',
                'descripcionAsociaciones',
                'asociacionesListado'
            ]);
    }
}

export default new ConfigQuery();
